import Vue from 'vue';
import http from '../utils/http';

export default {
    state: {
        insights: null,
    },
    mutations: {
        loadInsights(state, payload) {
			state.insights = payload;
		},
        addInsight(state, payload) {
            let index = state.insights?.length;
            if (!index) {
                index = 0;
            }
			Vue.set(state.insights, index, payload)   
        },
        editInsight(state, payload) {
            const item = state.insights?.find(m => m.id == payload.id)
            if (item) {
                let index = state.insights?.indexOf(item);
                Vue.set(state.insights, index, {...item, ...payload })  
            }      
        },
        deleteInsight(state, payload) {
            state.insights =  state.insights.filter(item => item.id !== payload)
        },
    },
    actions: {
        //fetch all insights by game id 
        async fetchInsights({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/insight/game/${payload.gameId}`);
                if (result) {
                   const insights = await result.data 
                   commit('loadInsights', insights)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async addInsight({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)

            const segment = payload.segment;
            delete payload.segment;

            try {
                const result = await http.post(`/insight`, payload);
                
                if (result) {
                   const insight = await result.data;
                   insight.segment = segment;
                   commit('addInsight', insight);
                }                              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async editInsight({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)

            try {
                const result = await http.put(`/insight/${payload.id}`, payload);
                
                if (result) {
                   await result.data; 
                   commit('editInsight', payload);
                }                              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async deleteInsight({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/insight/${payload}`);
                commit('deleteInsight', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
    },
    getters: {
        insights (state) {
            return state.insights;
        },
    }
}